// The id of our event's copy in Google, as the API's googleEventId gives it:
// external_id, else (events from before it existed) the dash-stripped uuid.
export const googleCopyId = (event) => event.external_id || event.id.replace(/-/g, '');

// The panel's side of the API's googleMoveRefusal: which Google events the
// calendar lets the dietitian drag. The API checks again before writing.
const MOVABLE_EVENT_TYPES = ['default', 'outOfOffice', 'focusTime'];

// Google's copies of our events carry the dash-stripped uuid. One outside the
// loaded list of ours (the two lists' windows differ at the edges) would
// otherwise pass for a Google event; ours move through athlisis.
const OUR_GOOGLE_ID = /^[0-9a-f]{32}$/;

export const canMoveGoogleEvent = (item) =>
  !OUR_GOOGLE_ID.test(item.id) &&
  !!item.start?.dateTime &&
  !!item.end?.dateTime &&
  Date.parse(item.end.dateTime) > Date.parse(item.start.dateTime) &&
  MOVABLE_EVENT_TYPES.includes(item.eventType ?? 'default') &&
  !item.locked &&
  !!(item.organizer?.self || item.guestsCanModify);

// Guests Google would email about a change: anyone but the dietitian and rooms.
export const hasOtherGuests = (item) =>
  !!item.attendees?.some((attendee) => !attendee.self && !attendee.resource);
